// One live audio session exists at a time — the voice agent owns it, because it
// owns the socket and the mic. Anything else that wants to start or watch it
// (the map popup's LIVE button) goes through these two window events rather
// than mounting a second useVoiceLive of its own and fighting for the mic.

// A popup can mount long after the session started, so the last announced
// state is kept here and replayed to new subscribers — otherwise its LIVE
// button reads "off" while a session is running and the next click stops it.
let lastState = 'idle';

const REQUEST = 'utms:voice-live-request';
const STATE = 'utms:voice-live-state';
const FOCUS = 'utms:focus-drone';

/** Ask the voice agent to toggle its live session on the selected drone. */
export function requestVoiceLive() {
    window.dispatchEvent(new CustomEvent(REQUEST));
}

/** Voice agent only: run `handler` when someone asks for a live session. */
export function onVoiceLiveRequest(handler) {
    window.addEventListener(REQUEST, handler);
    return () => window.removeEventListener(REQUEST, handler);
}

/** Voice agent only: announce 'idle' | 'connecting' | 'live'. */
export function publishVoiceLiveState(state) {
    lastState = state;
    window.dispatchEvent(new CustomEvent(STATE, { detail: state }));
}

/** Follow the live session's state. Returns an unsubscribe. */
export function onVoiceLiveState(handler) {
    const listener = (e) => handler(e.detail);
    handler(lastState);
    window.addEventListener(STATE, listener);
    return () => window.removeEventListener(STATE, listener);
}

/**
 * "map me drone B pe focus kar" — the same thing the recenter button does, asked
 * for in words. It moves the camera only; nothing reaches the vehicle, which is
 * why the NL route lets it through without a confirm tap.
 */
export function requestDroneFocus(droneId) {
    if (!droneId) return;
    window.dispatchEvent(new CustomEvent(FOCUS, { detail: droneId }));
}

/** Follow focus requests. Returns an unsubscribe. */
export function onDroneFocus(handler) {
    const listener = (e) => handler(e.detail);
    window.addEventListener(FOCUS, listener);
    return () => window.removeEventListener(FOCUS, listener);
}
